export const c = require("../assets/skills/c.png");
export const cpp = require("../assets/skills/cpp.png");
export const html = require("../assets/skills/html.png");
export const css = require("../assets/skills/css.png");
export const javascript = require("../assets/skills/javascript.png");
export const typescript = require("../assets/skills/typescript.png");
export const markdown = require("../assets/skills/markdown.png");
export const bootstrap = require("../assets/skills/bootstrap.png");
export const tailwind = require("../assets/skills/tailwind.png");
export const material = require("../assets/skills/material.png");
export const npm = require("../assets/skills/npm.png");
export const yarn = require("../assets/skills/yarn.png");
export const nodejs = require("../assets/skills/nodejs.png");
export const express = require("../assets/skills/express.png");
export const mongo = require("../assets/skills/mongo.png");
export const mongoose = require("../assets/skills/mongoose.png");
export const reactjs = require("../assets/skills/reactjs.png");
export const nextjs = require("../assets/skills/nextjs.png");
export const firebase = require("../assets/skills/firebase.png");
export const netlify = require("../assets/skills/netlify.png");
export const vercel = require("../assets/skills/vercel.png");
export const python = require("../assets/skills/python.png");
export const mysql = require("../assets/skills/mysql.png");
export const postman = require("../assets/skills/postman.png");
export const sanity = require("../assets/skills/sanity.png");
export const vite = require("../assets/skills/vite.png");
export const redux = require("../assets/skills/redux.png");

const stacks = [
    {
        src: c,
        tag: "C"
    },
    {
        src: cpp,
        tag: "C++"
    },
    {
        src: html,
        tag: "HTML"
    },
    {
        src: css,
        tag: "CSS"
    },
    {
        src: javascript,
        tag: "JavaScript"
    },
    {
        src: typescript,
        tag: "TypeScript"
    },
    {
        src: markdown,
        tag: "Markdown"
    },
    {
        src: bootstrap,
        tag: "Bootstrap"
    },
    {
        src: tailwind,
        tag: "Tailwind CSS"
    },
    {
        src: material,
        tag: "Material UI"
    },
    {
        src: npm,
        tag: "NPM"
    },
    {
        src: yarn,
        tag: "Yarn"
    },
    {
        src: vite,
        tag: "Vite"
    },
    {
        src: nodejs,
        tag: "Node.js"
    },
    {
        src: express,
        tag: "Express"
    },
    {
        src: mongo,
        tag: "MongoDB"
    },
    {
        src: mongoose,
        tag: "Mongoose"
    },
    {
        src: reactjs,
        tag: "React.js"
    },
    {
        src: nextjs,
        tag: "Next.js"
    },
    {
        src: redux,
        tag: "Redux"
    },
    {
        src: firebase,
        tag: "Firebase"
    },
    {
        src: sanity,
        tag: "Sanity"
    },
    {
        src: netlify,
        tag: "Netlify"
    },
    {
        src: vercel,
        tag: "Vercel"
    },
    {
        src: python,
        tag: "Python"
    },
    {
        src: mysql,
        tag: "MySQL"
    },
    {
        src: postman,
        tag: "Postman"
    },
]
export default stacks;